"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LineChart = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/material/styles");

var _Card = _interopRequireDefault(require("@mui/material/Card"));

var _CardHeader = _interopRequireDefault(require("@mui/material/CardHeader"));

var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _Table = _interopRequireDefault(require("@mui/material/Table"));

var _TableBody = _interopRequireDefault(require("@mui/material/TableBody"));

var _TableCell = _interopRequireDefault(require("@mui/material/TableCell"));

var _TableContainer = _interopRequireDefault(require("@mui/material/TableContainer"));

var _TableHead = _interopRequireDefault(require("@mui/material/TableHead"));

var _TableRow = _interopRequireDefault(require("@mui/material/TableRow"));

var _Paper = _interopRequireDefault(require("@mui/material/Paper"));

var _Divider = _interopRequireDefault(require("@mui/material/Divider"));

var _recharts = require("recharts");

var _reactI18next = require("react-i18next");

var CustomTooltip = function CustomTooltip(_ref) {
  var active = _ref.active,
      payload = _ref.payload,
      label = _ref.label;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var theme = (0, _styles.useTheme)();

  if (active && payload && payload.length) {
    var data = payload.at(0).payload; // TODO: Show label on heading

    return /*#__PURE__*/_react.default.createElement(_TableContainer.default, {
      component: _Card.default
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      sx: {
        textAlign: 'center',
        color: theme.palette.info.main,
        fontWeight: 'bold'
      }
    }, " ", t('intlDateTime', {
      val: new Date(label)
    }), " "), /*#__PURE__*/_react.default.createElement(_Divider.default, null), /*#__PURE__*/_react.default.createElement(_Table.default, {
      size: "small"
    }, /*#__PURE__*/_react.default.createElement(_TableBody.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "left",
      sx: {
        fontWeight: 'bold',
        color: theme.palette.text.secondary
      }
    }, " ", t('maximum'), " "), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right"
    }, " ", t('intlCurrencyWithOptions', {
      val: data.maximum
    }))), /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "left",
      sx: {
        fontWeight: 'bold',
        color: theme.palette.text.secondary
      }
    }, " ", t('minimum'), " "), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right"
    }, " ", t('intlCurrencyWithOptions', {
      val: data.minimum
    }), " ")), /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "left",
      sx: {
        fontWeight: 'bold',
        color: theme.palette.text.secondary
      }
    }, " ", t('modal'), " "), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right"
    }, "  ", t('intlCurrencyWithOptions', {
      val: data.modal
    }), " ")), /*#__PURE__*/_react.default.createElement(_TableRow.default, null, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "left",
      sx: {
        fontWeight: 'bold',
        color: theme.palette.text.secondary
      }
    }, " ", t('arrivals'), " "), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      align: "right"
    }, "  ", data.arrivals, " ")))));
  }

  return null;
};

var LineChart = function LineChart(_ref2) {
  var data = _ref2.data;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  var theme = (0, _styles.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_recharts.ResponsiveContainer, null, /*#__PURE__*/_react.default.createElement(_recharts.ComposedChart, {
    width: 500,
    height: 400,
    data: data,
    margin: {
      top: 4,
      bottom: 4,
      right: 8,
      left: 10
    }
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "maximum-fill",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "5%",
    stopColor: theme.palette.success.light,
    stopOpacity: 0.8
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "50%",
    stopColor: theme.palette.success.dark,
    stopOpacity: 0.8
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "95%",
    stopColor: theme.palette.success.main,
    stopOpacity: 0.8
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "minimum-stroke",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1%",
    stopColor: theme.palette.error.light,
    stopOpacity: 0.4
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "15%",
    stopColor: theme.palette.error.main,
    stopOpacity: 0.5
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "30%",
    stopColor: theme.palette.error.dark,
    stopOpacity: 0.6
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "60%",
    stopColor: theme.palette.warning.main,
    stopOpacity: 0.7
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "70%",
    stopColor: theme.palette.warning.dark,
    stopOpacity: 0.8
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "100%",
    stopColor: theme.palette.warning.light,
    stopOpacity: 0.9
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "minimum-fill",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1%",
    stopColor: theme.palette.error.light,
    stopOpacity: 0.4
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "15%",
    stopColor: theme.palette.error.main,
    stopOpacity: 0.5
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "30%",
    stopColor: theme.palette.error.dark,
    stopOpacity: 0.6
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "60%",
    stopColor: theme.palette.warning.main,
    stopOpacity: 0.7
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "70%",
    stopColor: theme.palette.warning.dark,
    stopOpacity: 0.8
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "100%",
    stopColor: theme.palette.warning.light,
    stopOpacity: 0.9
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "modal-stroke",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "5%",
    stopColor: theme.palette.info.light,
    stopOpacity: 0.1
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "50%",
    stopColor: theme.palette.info.main,
    stopOpacity: 0.7
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "95%",
    stopColor: theme.palette.info.dark,
    stopOpacity: 0.5
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "arrivals-fill",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "5%",
    stopColor: theme.palette.secondary.light,
    stopOpacity: 0.1
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "50%",
    stopColor: theme.palette.secondary.main,
    stopOpacity: 0.7
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "95%",
    stopColor: theme.palette.secondary.dark,
    stopOpacity: 0.5
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "arrivals-stroke",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "5%",
    stopColor: theme.palette.secondary.light,
    stopOpacity: 0.1
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "50%",
    stopColor: theme.palette.secondary.main,
    stopOpacity: 0.7
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "95%",
    stopColor: theme.palette.secondary.dark,
    stopOpacity: 0.5
  }))), /*#__PURE__*/_react.default.createElement(_recharts.CartesianGrid, {
    strokeDasharray: "3 3",
    stroke: theme.palette.text.disabled
  }), /*#__PURE__*/_react.default.createElement(_recharts.XAxis, {
    angle: -35,
    scale: "auto",
    domain: [data.at(0).date, data.at(-1).date],
    tick: function tick(props) {
      var x = props.x,
          y = props.y,
          stroke = props.stroke,
          payload = props.payload;
      return /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(".concat(x, ",").concat(y, ")")
      }, /*#__PURE__*/_react.default.createElement("text", {
        x: 0,
        y: 0,
        dy: 16,
        fill: "#666"
      }, /*#__PURE__*/_react.default.createElement("tspan", {
        textAnchor: "middle",
        x: "0"
      }, t('intlDateTime', {
        val: new Date(payload.value),
        month: '2-digit',
        day: '2-digit'
      }))));
    },
    dataKey: "date"
  }), /*#__PURE__*/_react.default.createElement(_recharts.YAxis, {
    domain: [Math.min.apply(null, data.map(function (item) {
      return item.maximum;
    })), Math.max.apply(null, data.map(function (item) {
      return item.maximum;
    }))],
    allowDataOverflow: true,
    mirror: true,
    orientation: "left",
    dx: 2,
    dy: 64,
    angle: -90,
    tickFormatter: function tickFormatter(tick) {
      if (tick === 0) {
        return '';
      }

      return t('intlCurrencyWithOptions', {
        val: tick,
        maximumSignificantDigits: 2
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_recharts.Tooltip, {
    content: /*#__PURE__*/_react.default.createElement(CustomTooltip, null)
  }), /*#__PURE__*/_react.default.createElement(_recharts.Legend, {
    layout: "horizontal",
    align: "right",
    verticalAlign: "top",
    formatter: function formatter(value, entry, index) {
      var style = {};

      switch (value) {
        case 'minimum':
          style.color = theme.palette.warning.dark;
          break;

        case 'maximum':
          style.color = theme.palette.primary.dark;
          break;

        case 'modal':
          style.color = theme.palette.info.dark;
          break;

        case 'arrivals':
          style.color = theme.palette.secondary.dark;
          break;
      }

      return /*#__PURE__*/_react.default.createElement("span", {
        style: style
      }, " ", value, " ");
    }
  }), /*#__PURE__*/_react.default.createElement(_recharts.Bar, {
    type: "monotone",
    dataKey: "maximum",
    fill: "url(#maximum-fill)"
  }), /*#__PURE__*/_react.default.createElement(_recharts.Area, {
    type: "monotone",
    dataKey: "minimum",
    strokeWidth: 3,
    stroke: "url(#minimum-stroke)",
    fill: "url(#minimum-fill)"
  }), /*#__PURE__*/_react.default.createElement(_recharts.Line, {
    dataKey: "modal",
    strokeWidth: 3,
    dot: {
      stroke: theme.palette.success.light,
      strokeWidth: 0,
      fill: theme.palette.success.dark,
      r: 2
    },
    type: "monotone",
    stroke: "url(#modal-stroke)"
  }), /*#__PURE__*/_react.default.createElement(_recharts.ZAxis, {
    type: "number",
    dataKey: "arrivals",
    name: "arrivals",
    unit: "quintal"
  }), /*#__PURE__*/_react.default.createElement(_recharts.Scatter, {
    dataKey: "arrivals",
    line: true,
    strokeDasharray: "4 4",
    stroke: "url(#arrivals-stroke)",
    fill: "url(#arrivals-fill"
  })));
};

exports.LineChart = LineChart;